<template>
  <section class="secCheckout checkout" id="secCheckout">
    <div class="mask" v-if="showMask" @click="hideAllModals"></div>

    <me-loading :loading="loading"></me-loading>

    <div class="container container--checkout">
      <ul class="formSteps formSteps--3">
        <li class="formSteps__step" :class="{ 'formSteps__step--active': step >= 1 }">
          <div>
            <span class="number">1</span>
            <p class="name">Carrinho</p>
          </div>
        </li>
        <li class="formSteps__step" :class="{ 'formSteps__step--active': step >= 2 }">
          <div>
            <span class="number">2</span>
            <p class="name">Pagamento</p>
          </div>
        </li>
        <li class="formSteps__step" :class="{ 'formSteps__step--active': step >= 3 }">
          <div>
            <span class="number">3</span>
            <p class="name">Confirmação</p>
          </div>
        </li>
      </ul>

      <template v-if="purchase.status === 'paid'">
        <div class="headerInfo">
          <h2 class="ttl">O SEU PAGAMENTO FOI APROVADO!</h2>
          <template>
            <p class="subTtl">{{ purchaseText }}</p>
          </template>

          <div class="buttons">
            <a href="/painel/meus-envios#liberados" class="btnBorder"><span>Meus envios</span></a>
            <a href="javascript:;" @click="checkPrint()" class="btnColor -ico-right">
              <span>{{ checkPrintButtonLabel }}</span>

              <ion-icon v-if="isAllShowCorreiosPPNOrders" name="receipt-outline" class="ico" />
              <svg v-else class="ico"><use xlink:href="/images/svg-symbols.svg#print"></use></svg>
            </a>
          </div>
        </div>

        <div class="totalBox">
          <div class="bar">
            <ion-icon class="bar__icon" name="information-circle"></ion-icon>
            <div class="bar__content">
              <span>O preço exibido aqui já inclui a taxa de intermediação do Melhor Envio, fazendo com que seja diferente do preço que aparece na nota entregue pela transportadora.</span><br/>
              <a href="javascript:;" @click="showModal('informationModal')">Como é calculado o  preço do frete?</a>
            </div>
            <div class="bar__totals">
              <label>Total</label>
              <span>{{ total.total | currency }}</span>
              <a href="javascript:;" @click="showDetails" class="detailsLink">{{ detailsTitle }}</a>
            </div>
          </div>

          <div class="detailsBox" :class="{'-show': details}">
            <ul>
              <template v-if="total.mixed_payment">
                <li>
                  <p class="title">Carteira</p>
                  <span>{{ total.wallet_value | currency }}</span>
                </li>
                <li>
                  <p class="title">Meio de Pagamento</p>
                  <span>{{ total.gateway_value | currency }}</span>
                </li>
              </template>
              <template v-else>
                <template v-if="total.wallet_value === 0 && total.gateway_value > 0">
                  <li>
                    <p class="title">Meio de Pagamento</p>
                    <span>{{ total.gateway_value | currency }}</span>
                  </li>
                </template>
                <template v-else>
                  <template v-if="total.gateway_value === 0">
                    <li>
                      <p class="title">Carteira</p>
                      <span>{{ total.wallet_value | currency }}</span>
                    </li>
                  </template>
                  <template v-else>
                    <li>
                      <p class="title">Meio de Pagamento</p>
                      <span>{{ total.gateway_value | currency }}</span>
                    </li>
                  </template>
                </template>
              </template>

              <li>
                <p class="title">Total pago</p>
                <span class="total">{{ total.total | currency }}</span>
              </li>
            </ul>
          </div>
        </div>

        <ul class="lstCheckout">
          <checkout-status-item
             v-for="(item, index) in purchase.orders"
            :index="index"
            :key="index"
          />
        </ul>
      </template>

      <template v-else-if="purchase.payment && purchase.payment.status === 'unauthorized'">
        <div class="headerInfo">
          <h2 class="ttl">OPS! Algo deu errado...</h2>
          <p class="subTtl">A forma de pagamento escolhida não foi autorizada pelo {{ purchase.payment.gateway.name }}. Verifique o que aconteceu e tente novamente mais tarde ou escolha outra forma de pagamento!</p>
          <div class="buttons">
            <a href="javascript:;" class="btnClean"><span>ESCOLHER OUTRA FORMA DE PAGAMENTO</span></a>
          </div>
        </div>
      </template>

      <template v-else-if="purchase.status === 'pending'">
        <div class="headerInfo">
          <h2 class="ttl">O SEU PEDIDO ESTÁ SENDO PROCESSADO...</h2>

          <div class="payments">
            <p class="subTtl">Suas etiquetas estarão disponíveis assim que a transação for autorizada pelo meio escolhido. Se o pagamento já foi efetuado, confira os prazos de processamento e aguarde identificação.</p>
            <div class="payments__container payments__container--status">
              <img class="payments__ilustration" src="/images/ilustrations/checkout-status.svg" />
              <payment-description status :gateway="purchase.payment.gateway" />
            </div>

            <p class="subTtl">Você pode acompanhar, excluir ou escolher outra forma para pagar seus pedidos em Meus Envios na aba “Aguardando Pagamento”.</p>
          </div>

          <div class="buttons">
            <a href="/painel/meus-envios#aguardando" class="btnBorder"><span>ver envios aguardando pagamento</span></a>
          </div>
        </div>
      </template>
    </div>

    <transition name="fade">
      <div class="modal modal--small modal--center" v-if="modalAlert">
        <div class="modal__header">
          <p>{{ modalAlertHeader }}</p>

          <a href="javascript:;" class="closeModal"><svg class="ico" @click="hideModal('modalAlert')"><use xlink:href="/images/svg-symbols.svg#close"></use></svg></a>
        </div>
        <div class="modal__content">
          <p v-html="modalAlertText"></p>
        </div>
        <div class="modal__footer">
          <div class="modal__footer__row">
            <a type="button" class="btnBorder btnBorder--small modal__footer__row__button" href='/painel/meus-envios'><span>Ir para meus envios </span></a>
            <button type="button" class="btnColor modal__footer__row__button" @click="hideModal('modalAlert')"><span>{{ modalAlertButton }} </span></button>
          </div>

        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="modal information-modal modal--small modal--center" v-if="informationModal">
        <div class="modal__header">
          <p>Como é calculado o preço do frete?</p>

          <a href="javascript:;" class="closeModal" @click="hideModal('informationModal')">
            <svg class="ico">
              <use xlink:href="/images/svg-symbols.svg#close"></use>
            </svg>
          </a>
        </div>

        <div class="modal__content">
          <p>Os preços exibidos no Melhor Envio são calculados pela soma do preço de custo do frete com a nossa taxa de intermediação.</p>
          <p>
            <ul>
              <li>Preço de custo do frete: valor exclusivo garantido por contrato com as transportadoras</li>
              <li>Taxa de intermediação: valor adicionado ao preço de custo do frete e única fonte de monetização da plataforma</li>
            </ul>
          </p>
          <p>O valor da taxa de intermediação não aparece na notinha ou no DACTE. É por isso que o valor da nota entregue pela transportadora é diferente.</p>
          <p><a href="https://ajuda.melhorenvio.com.br/pt-BR/articles/4381675-por-que-a-nota-da-transportadora-informa-um-valor-menor" target="_blank" rel="noopener noreferrer">Clique aqui</a> e saiba mais sobre a nossa taxa de intermediação.</p>
        </div>

        <div class="modal__footer">
          <div class="modal__footer__row">
            <button
              type="button"
              class="btnColor modal__footer__row__button"
              @click="hideModal('informationModal')"
            >
              <span>Entendi</span>
            </button>
          </div>
        </div>
      </div>
    </transition>

    <modal-print-loggi-collect
      ref="modalV2PrintLoggiCollect"
      :order="currentIndex"
      @close-modal="rejectLoggiCollect"
      @continue="continueLoggiCollect"
    />

    <modal-reverse-logistic
      ref="reverseLogisticModal"
      @generated="setCorreiosPPNGenerated"
    />

    <modal-print-preferences
      ref="printPreferencesModal"
      :order="currentIndex"
      @confirm="continuePrintPreferences"
    />

    <print-alert
      ref="modalV2PrintAlert"
      :print-orders="printOrders"
      :print-settings="printSettings"
      should-hide-expired-text
      @confirm-print="modalAlertActionFunction"
      @cancel-print="cancelPrint"
    />
  </section>
</template>

<script>
  import { clearPrintPreference, getPrintPreference, setPrintPreference } from 'commons/js/utils/print';

  import checkoutStatusItem from './checkout-status/Item.vue';
  import AnalyticsTracking from 'commons/js/AnalyticsTracking';
  import PrintAlert from './checkout/PrintAlert';
  import ShippingDefinitions from '@assets/commons/js/ShippingDefinitions';
  import PaymentDescription from 'dash/js/components/payments/PaymentDescription.vue';
  import ModalPrintLoggiCollect from 'commons/js/components/modals/ModalPrintLoggiCollect';
  import ModalReverseLogistic from 'commons/js/components/modals/ModalReverseLogistic';
  import ModalPrintPreferences from 'commons/js/components/modals/ModalPrintPreferences';

  export default {
    mixins: [
      AnalyticsTracking,
      ShippingDefinitions
    ],

    components : {
      'checkout-status-item': checkoutStatusItem,
      PrintAlert,
      PaymentDescription,
      ModalPrintLoggiCollect,
      ModalReverseLogistic,
      ModalPrintPreferences,
    },

    props: {
      purchaseId: {
        type: String,
        required: true
      },
      userEmail: {
        type: String,
        required: false
      }
    },

    data() {
      return {
        loading: false,
        step: 2,
        confirmPrint: 1,
        setConfirmPrint: 1,
        purchase: {
          status: '',
          orders: [],
        },
        generatedCorreiosPPN: [],
        printSettings: {},
        printOrders: [],
        showMask: false,
        informationModal: false,
        modalAlert: false,
        modalAlertHeader: 'Atenção!',
        modalAlertText: '',
        modalAlertButton: 'Tentar novamente',
        modalAlertActionButton: '',
        modalAlertActionFunction: () => {},
        detailsTitle: 'Mostrar detalhes',
        details: false,
        isProductionEnvironment: MEConfig.get('app.env') === 'production',
        currentIndex: undefined,
        shouldShowPrintPreferencesModal: !MEConfig.get('preferences.print_preferences_alert'),
      }
    },

    filters: {
      currency(value, currency = 'R$', hasZero = true) {
        value = String(value);
        let matches = value.match(/(\,|\.)(\d{2})$/);
        if (matches && matches.length >= 3) {
          value = value.substr(0, value.length - 3).replace(/\D/g, '') + '.' + matches[2];
        }
        value = parseFloat(value);
        if (!(value && !isNaN(value) && isFinite(value))) value = 0;
        if (!hasZero && !value) return '-';
        return currency + ' ' + Number(value).toLocaleString('pt-BR', {
          currency: 'BRL',
          minimumFractionDigits: 2
        });
      },
    },

    computed: {
      purchaseText() {
        return this.purchase.orders.length > 1 ? 'A partir de agora você já pode imprimir suas etiquetas e realizar o envio dos seus produtos.' : 'A partir de agora você já pode imprimir sua etiqueta e realizar o envio do seu produto.';
      },

      total() {
        let result = {
          subtotal: 0,
          mixed_payment: false,
          wallet_value: 0,
          gateway_value: 0,
          total: 0,
        };
        let transactions = this.purchase.transactions;

        if (transactions.length === 2) {
          result.mixed_payment = true;
          for (let i = 0; i < transactions.length; i++) {
            if (transactions[i].reserved_at) {
              result.wallet_value = transactions[i].value;
            } else {
              result.gateway_value = transactions[i].value;
            }
          }
        } else {
          if (!this.purchase.payment) {
            result.wallet_value = transactions[0].value;
          } else {
            result.gateway_value = transactions[0].value;
          }
        }

        result.subtotal = result.wallet_value + result.gateway_value;
        result.total = result.wallet_value + result.gateway_value;
        return result;
      },

      hasLoggiCollect() {
        return this.purchase.orders.some(purchase => this.isLoggiCollect(purchase.service.id));
      },

      hasMultipleOrders() {
        return this.purchase.orders.length > 1;
      },

      commonCorreiosPPNOrders() {
        return this.purchase.orders.filter(({is_show_correios_reverse_ppn_action }) => !is_show_correios_reverse_ppn_action);
      },

      correiosPPNOrders() {
        return this.purchase.orders.filter(purchase =>
          purchase.is_show_correios_reverse_ppn_action
          && !this.getCorreiosPPNGenerated(purchase)
        );
      },

      isAllShowCorreiosPPNOrders() {
        return this.purchase.orders.every(purchase => purchase.is_show_correios_reverse_ppn_action);
      },

      hasCorreiosPPNOrders() {
        return this.correiosPPNOrders.length;
      },

      checkPrintButtonLabel() {
        if (this.isAllShowCorreiosPPNOrders) {
          return 'Gerar código';
        }
        return this.hasMultipleOrders ? 'Gerar etiquetas' : 'Gerar etiqueta';
      },
    },

    created() {
      clearPrintPreference();

      this.loadPurchase();
      this.loadPreferences();
      this.addEmailToDataLayer();
    },

    methods: {
      async loadPreferences() {
        try {
          const res = await axios.get('/api/v2/me/preferences/print-alerts');
          this.printSettings = res.data;
        } catch (error) {
          console.error('=>', error);
        }
      },

      loadPurchase() {
        axios.get('/api/v2/me/purchases/' + this.purchaseId).then((response) => {
          if (response.data) {
            this.purchase = response.data;

            this.$store.commit('SET_SELECTED_METHOD', this.purchase.payment ? this.purchase.payment.gateway.slug : 'wallet');

            this.paymentTracking(this.purchase.id, parseFloat(this.purchase.total));

            if (this.purchase.status === 'paid') {
              this.step = 3;
            }
          } else {
            this.showModal('modalAlert');
            this.modalAlertText = 'Não foi encontrado informações desse pagamento';
          }
        }).catch(() => {
          this.showModal('modalAlert');
          this.modalAlertText = 'Não foi encontrado informações desse pagamento';
        });
      },

      addEmailToDataLayer() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({'email': this.userEmail});
      },

      cancelPrint() {
        this.currentIndex = undefined;
        this.$refs.modalV2PrintAlert.close();
      },

      redirectToMyOrders() {
        window.location.href = '/painel/meus-envios';
      },

      async checkPrint(index) {
        const hasIndex = index !== undefined;

        if (!hasIndex && this.hasCorreiosPPNOrders) {
          const orders = hasIndex ? [this.purchase.orders[index]] : this.correiosPPNOrders;

          const shouldRedirect = hasIndex
            ? this.isAllShowCorreiosPPNOrders && this.correiosPPNOrders.length === 1
            : this.isAllShowCorreiosPPNOrders;

          const confirmed = await this.$refs.reverseLogisticModal.generate(orders);

          if (confirmed && shouldRedirect) return this.redirectToMyOrders();
          else if (!confirmed || hasIndex) return;
        }

        if (this.hasLoggiCollect) {
          this.currentIndex = index;
          this.$refs.modalV2PrintLoggiCollect.open();
          return;
        }

        this.print(index);
      },

      continueLoggiCollect(index) {
        this.print(index);
      },

      rejectLoggiCollect() {
        this.$refs.modalV2PrintLoggiCollect.close();
      },

      continuePrintPreferences(orders, quality) {
        setPrintPreference(quality);
        this.$refs.printPreferencesModal.close();
        this.generate(orders);
      },

      print(index) {
        this.modalPrintOrders(index !== undefined ? [this.purchase.orders[index]] : this.commonCorreiosPPNOrders);
      },

      modalPrintOrders(orders) {
        if (!this.shouldShowPrintAlertModal(orders)) {
          if (this.shouldShowPrintPreferencesModal) {
            this.currentIndex = orders;
            this.$refs.printPreferencesModal.open();
            return;
          }

          this.generate(orders);
          return;
        }

        this.printOrders = orders;
        this.$refs.modalV2PrintAlert.open();
        this.modalAlertActionFunction = () => {
          if (this.shouldShowPrintPreferencesModal) {
            this.currentIndex = orders;
            this.$refs.printPreferencesModal.open();
            return;
          }

          this.generate(orders);
        };
      },

      shouldShowPrintAlertModal(orders) {
        const printSettings = this.formatPrintSettingsByCompanyId();

        return orders.some(order => {
          const setting = printSettings[order.service.company.id];
          if ('collect' in setting) {
            if (order.collect) {
              return !setting.collect && !order.generated_at;
            }
          }
          return !setting.desk && !order.generated_at;
        });
      },

      formatPrintSettingsByCompanyId() {
        return {
          [ShippingDefinitions.CORREIOS_ID]: {
            desk: this.printSettings.correios_print_alert,
          },
          [ShippingDefinitions.JADLOG_ID]: {
            desk: this.printSettings.jadlog_print_alert,
          },
          [ShippingDefinitions.LATAM_CARGO_ID]: {
            collect: this.printSettings.latam_cargo_collect_print_alert,
            desk: this.printSettings.latam_cargo_desk_print_alert,
          },
          [ShippingDefinitions.AZUL_CARGO_EXPRESS_ID]: {
            desk: this.printSettings.azul_cargo_express_print_alert,
          },
          [ShippingDefinitions.BUSLOG_ID]: {
            desk: this.printSettings.buslog_print_alert,
          },
          [ShippingDefinitions.LOGGI_ID]: {
            desk: this.printSettings.loggi_print_alert,
          },
          [ShippingDefinitions.JET_ID]: {
            desk: this.printSettings.jet_print_alert,
          },
        };
      },

      generate(orders) {
        this.loading = true;
        const endpoint = '/api/v2/me/shipment/tag/generate';

        axios.post(endpoint, {
          orders: orders.filter((e) => !e.generated_at).map((e) => e.id),
          printQuality: getPrintPreference(),
        }).then((response) => {
          this.loading = false;
          if (response.status === 204) {
            this.showModal('modalAlert');
            this.modalAlertHeader = 'Atenção! Falha ao gerar suas etiquetas';
            this.modalAlertText = 'Não foi possível gerar o link de impressão. Por favor, aguarde 30 segundos e tente novamente.';
            this.modalAlertButton = 'Fechar';
            return;
          }

          axios.post('/api/v2/me/shipment/print', {
            orders: orders.map((e) => e.id)
          }).then((response) => {
            const bc = new BroadcastChannel('background-tags');
            bc.postMessage('start-generation');
            setTimeout(() => {
              location.href = response.data.url || '/painel/meus-envios';
            }, 2000);
          }).catch(() => {
            this.loading = false;
            this.$refs.modalV2PrintAlert.close();
            this.showModal('modalAlert');
            this.modalAlertText = 'Não foi possível gerar o link de impressão.';
            this.modalAlertButton = 'Fechar';
            setTimeout(() => {
              location.href = '/painel/meus-envios';
            }, 5000);
          });
        }).catch(() => {
          this.loading = false;
          this.$refs.modalV2PrintAlert.close();
          this.showModal('modalAlert');
          this.modalAlertHeader = 'Atenção! Falha ao gerar suas etiquetas.';
          this.modalAlertText = `
            <p>
              <span>Uma instabilidade no sistema da transportadora impediu a geração de uma ou mais etiquetas. Por favor, tente novamente mais tarde.</span>
              <a href='https://ajuda.melhorenvio.com.br/pt-BR/articles/4704712-instabilidade-no-sistema-da-transportadora-como-isso-me-afeta' target='_blank' rel="noopener noreferrer">Saiba mais.</a>
            </p>
          `;
          this.modalAlertButton = 'Fechar';
        });
      },

      showModal(modal) {
        this[modal] = true;
        this.showMask = true;
      },

      hideModal(modal) {
        this[modal] = false;
        this.showMask = false;
        this.modalAlertButton = 'Tentar novamente';
        this.modalAlertActionButton = '';
        this.modalAlertActionFunction = () => {};
        this.modalAlertRedirectButton = 'true';
      },

      hideAllModals() {
        this.showMask = false;
        this.modalAlert = false;
        this.modalAlertButton = 'Tentar novamente';
        this.modalAlertActionButton = '';
        this.modalAlertActionFunction = () => {};
      },

      showDetails() {
        this.details = !this.details;
        this.detailsTitle = (this.details) ? 'Ocultar detalhes' : 'Mostrar detalhes';
      },

      setCorreiosPPNGenerated(orders) {
        this.generatedCorreiosPPN = orders;
      },

      getCorreiosPPNGenerated(order) {
        return !!this.generatedCorreiosPPN.find((id) => id === order.id);
      },
    }
  }
</script>


<style lang="stylus" scoped>
  .modal__footer__row
    display flex
    flex-direction column
    align-items center
    justify-content center
    width 100% !important
    margin-top -20px

    @media screen and (min-width 720px)
      flex-direction row
      margin-top -10px

    &__button
      font-size 1rem !important

      &:first-child
        @media screen and (min-width 720px)
          margin 0 16px 0 0 !important

</style>
